/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import DLSThemeFontLoader from '../../DLSThemeFontLoader';
import {Reseller} from '../Resellers';
import useReseller from '../useReseller';
import DefaultFontLoader from './DefaultFontLoader';
import ResellerFontLoader from './ResellerFontLoader';

/**
 * Map of resellers that have custom font implementations. Resellers in this
 * map will use {@link ResellerFontLoader} to load their custom fonts from
 * their respective public directories. Resellers not in this map will use
 * the default font loaders.
 */
const customFontResellers = {
  [Reseller.RACConnect] : true,
  [Reseller.Ayvens]     : true
};

/**
 * Renders the appropriate font loader based on the current reseller. If the
 * current reseller is a reseller that defines custom fonts, this component
 * will render the {@link ResellerFontLoader}, otherwise, the default Fonts
 * from {@link DLSThemeFontLoader} and {@link DefaultFontLoader}. will be
 * loaded.
 *
 * ```typescript
 *  import FontLoader from './FontLoader';
 *  ...
 *
 *  <FontLoader />
 * ```
 *
 * @returns A React element corresponding to the appropriate font loader.
 */
export const FontLoader: React.FC = () => {
  const {isReseller, reseller} = useReseller();

  if (isReseller && customFontResellers[reseller as Reseller]) {
    return <ResellerFontLoader />;
  }
  return (
    <>
      <DLSThemeFontLoader />
      <DefaultFontLoader />
    </>
  );
};

export default FontLoader;
